<template>
  <div id="app">
      <router-view></router-view>
      <Footer/>
      <button class="global-service-btn" type="button" aria-label="service" @click="toService">
        <img src="./assets/img/kf.png" alt="">
      </button>
  </div>
</template>

<script>
import Footer from './common/Footer'
export default {
  name: 'app',
  components: {
    Footer
  },
  data() {
    return {
      status:0
    };
  },
  methods: {
    getBaseInfo(){
      this.$http({
        method: 'get',
        url: 'base_info'
      }).then(res=>{
        this.$store.commit('setBaseInfoValue', res.data);
      })
    },
    toService() {
      const service = this.$store.getters.getBaseInfo;
      if (service && service.iskefu == 1 && service.kefu) {
        window.location.href = service.kefu;
        return;
      }
      this.$http({
        method: 'get',
        url: 'base_info'
      }).then(res => {
        const config = res.data || {};
        this.$store.commit('setBaseInfoValue', config);
        if (config.iskefu == 1 && config.kefu) {
          window.location.href = config.kefu;
        } else {
          this.$toast('\u5ba2\u670d\u6682\u672a\u5f00\u542f');
        }
      }).catch(() => {
        this.$toast('\u5ba2\u670d\u6682\u672a\u5f00\u542f');
      });
    }

  },
  created(){
    this.getBaseInfo();
  }
}
</script>

<style>
body .van-toast {
  font-size: 38px;
  padding: 30px;
  line-height: 50px;
  width: 230px;
}
body .van-toast .van-toast__icon {
  font-size: 50px;
}
*, :after, :before {
  box-sizing: border-box;
}
.global-service-btn {
  position: fixed;
  right: 28px;
  bottom: 130px;
  z-index: 3000;
  width: 104px;
  height: 104px;
  padding: 0;
  border: 0;
  border-radius: 50%;
  background: transparent;
  box-shadow: 0 10px 22px rgba(0, 0, 0, .28);
}
.global-service-btn img {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: contain;
}
</style>
